import React from "react";
import "./styles.css";

const DemandAndSupply = () => {
  return (
    <div className="container">
      <h1>Demand And Supply</h1>
      <h2>Demand and Quantity Demanded</h2>
      <p>Demand, indicates how much a good, or service is wanted. Quantity demanded, indicates how much of a good, or service is wanted.</p>
      <p>The following determine the quantity demanded of a good, or service:</p>
        <ul>
          <li>The price of the product;</li>
          <li>The prices of substitutes, and compliments;</li>
          <li>Changes in consumer income, and wealth;</li>
          <li>Changes in consumer tastes, and preferences; and</li>
          <li>Individual specific, and environmental factors.</li>
        </ul>
      <h2>The Law of Demand</h2>
      <p>An increase in the price of a product, keeping all other variables constant, or <i>cetaris paribus</i>, results in a decrease in quantity demanded. A decrease in the price of a product, keeping all other variables constant, or <i>cetaris paribus</i>, results in an increase in the quantity demanded. This is the Law of Demand.</p>
      <h2>The Demand Curve</h2>
      <p>The demand curve is downward sloping from left to right. This represents the negative relationship between price, and quantity demanded. A change in price, or quantity demanded is always a movement along the curve. A change in any other variable affecting demand shall cause a shift of the demand curve.</p>
      <h2>Supply and Quantity Supplied</h2>
      <p>Supply, is a measure of the market availability of a good, or service. Quantity supplied, is a measure of how much the market availability is of a good, or service.</p>
      <p>The following determine the quantity supplied of a good, or service:</p>
      <ul>
        <li>The price of the product;</li>
        <li>The prices of input factors of production; and</li>
        <li>The state of technology, representing how efficiently input factors of production can be turned in to marketable output.</li>
      </ul>
      <h2>The Law of Supply</h2>
      <p>An increase in the price of a product, keeping all other variables constant, or <i>cetaris paribus</i>, results in an increase in quantity supplied. A decrease in the price of a product, keeping all other variables constant, or <i>cetaris paribus</i>, results in a decrease in the quantity supplied. This is the Law of Supply.</p>
      <h2>The Supply Curve</h2>
      <p>The supply curve is upward sloping from left to right. This represents the positive relationship between price, and quantity demanded. A change in price, or quantity supplied is always a movement along the curve. A change in any other variable affecting supply shall cause a shift of the supply curve.</p>
      <h2>Equilibrium Price and Quantity</h2>
      <p>When the demand for a good, or service is greater than its supply, the market price rises. When the demand for a good, or service is less than its supply, the market price falls. This is the Law of Price Adjustment.</p>
      <p>When quantity demanded, equals quantity supplied, the market is said to be at equilibrium. At equilibrium price, and quantity demanded, equals supply, and consumer, and producer surpluses are equal.</p>
    </div>
  );
};

export default DemandAndSupply;